module.exports = __webpack_public_path__ + "img/hocvivu logo-01 1 (3).591be4b2.png";